{
    "ka": {
        "Yes": "კი",
        "No": "არა",
        "Cancel": "გაუქმება",
        "Close": "დახურვა",
        "Clear": "გასუფთავება",
        "Done": "მზადაა",
        "Loading": "იტვირთება...",
        "Select": "არჩევა...",
        "Search": "ძებნა",
        "Back": "უკან",
        "OK": "OK",
        "dxCollectionWidget-noDataText": "მონაცემები არ არის",
        "dxList-pullingDownText": "გასაახლებლად ჩამოწიეთ...",
        "dxList-pulledDownText": "გასაახლებლად გაუშვით...",
        "dxList-refreshingText": "განახლება...",
        "dxList-pageLoadingText": "იტვირთება...",
        "dxList-nextButtonText": "მეტი",
        "dxList-selectAll": "ყველას მონიშვნა",
        "dxListEditDecorator-delete": "წაშლა",
        "dxListEditDecorator-more": "მეტი",
        "dxDataGrid-editingEditRow": "რედაქტირება",
        "dxDataGrid-editingSaveRowChanges": "შენახვა",
        "dxDataGrid-editingCancelRowChanges": "გაუქმება",
        "dxDataGrid-editingDeleteRow": "წაშლა",
        "dxDataGrid-groupPanelEmptyText": "დაჯგუფებისთვის გადმოიტანეთ სვეტის სათაური აქ",
        "dxDataGrid-noDataText": "მონაცემები არ არის",
        "dxDataGrid-searchPanelPlaceholder": "ძებნა...",
        "dxDataGrid-filterRowShowAllText": "(ყველა)",
        "dxDataGrid-filterRowResetOperationText": "გასუფთავება",
        "dxDataGrid-filterRowOperationEquals": "უდრის",
        "dxDataGrid-filterRowOperationNotEquals": "არ უდრის",
        "dxDataGrid-filterRowOperationLess": "ნაკლებია",
        "dxDataGrid-filterRowOperationLessOrEquals": "ნაკლებია ან ტოლი",
        "dxDataGrid-filterRowOperationGreater": "მეტია",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "მეტია ან ტოლი",
        "dxDataGrid-filterRowOperationStartsWith": "იწყება",
        "dxDataGrid-filterRowOperationContains": "შეიცავს",
        "dxDataGrid-filterRowOperationNotContains": "არ შეიცავს",
        "dxDataGrid-filterRowOperationEndsWith": "მთავრდება",
        "dxDataGrid-filterRowOperationBetween": "შუაში",
        "dxDataGrid-applyFilterText": "ფილტრის გამოყენება",
        "dxDataGrid-trueText": "ჭეშმარიტი",
        "dxDataGrid-falseText": "მცდარი",
        "dxDataGrid-sortingAscendingText": "ზრდადობით სორტირება",
        "dxDataGrid-sortingDescendingText": "კლებადობით სორტირება",
        "dxDataGrid-sortingClearText": "სორტირების გაუქმება",
        "dxDataGrid-editingSaveAllChanges": "ცვლილებების შენახვა",
        "dxDataGrid-editingCancelAllChanges": "ცვლილებების გაუქმება",
        "dxDataGrid-editingAddRow": "რიგის დამატება",
        "dxDataGrid-summaryMin": "მინ: {0}",
        "dxDataGrid-summaryMax": "მაქს: {0}",
        "dxDataGrid-summaryAvg": "საშ: {0}",
        "dxDataGrid-summarySum": "ჯამი: {0}",
        "dxDataGrid-summaryCount": "რაოდენობა: {0}",
        "dxDataGrid-columnFixingFix": "ფიქსირება",
        "dxDataGrid-columnFixingUnfix": "მოხსნა",
        "dxDataGrid-columnFixingLeftPosition": "მარცხნივ",
        "dxDataGrid-columnFixingRightPosition": "მარჯვნივ",
        "dxDataGrid-exportTo": "ექსპორტი",
        "dxDataGrid-exportToExcel": "Excel-ში ექსპორტი",
        "dxDataGrid-excelFormat": "Excel ფაილი",
        "dxDataGrid-exportAll": "ყველა მონაცემის ექსპორტი",
        "dxDataGrid-exportSelectedRows": "მონიშნული რიგების ექსპორტი",
        "dxDataGrid-selectedRows": "მონიშნული რიგები",
        "dxDataGrid-headerFilterOK": "OK",
        "dxDataGrid-headerFilterCancel": "გაუქმება",
        "dxPager-infoText": "გვერდი {0} - {1} ({2}-დან)",
        "dxPager-pagesCountText": "-დან",
        "dxPager-pageSizesAllText": "ყველა",
        "dxDateBox-simulatedDataPickerTitleTime": "აირჩიეთ დრო",
        "dxDateBox-simulatedDataPickerTitleDate": "აირჩიეთ თარიღი",
        "dxDateBox-simulatedDataPickerTitleDateTime": "აირჩიეთ თარიღი და დრო",
        "dxDateBox-validation-datetime": "მნიშვნელობა უნდა იყოს თარიღი ან დრო",
        "dxFileUploader-selectFile": "აირჩიეთ ფაილი",
        "dxFileUploader-dropFile": "ან გადმოიტანეთ ფაილი აქ",
        "dxFileUploader-bytes": "ბაიტი",
        "dxFileUploader-kb": "კბ",
        "dxFileUploader-Mb": "მბ",
        "dxFileUploader-Gb": "გბ",
        "dxFileUploader-upload": "ატვირთვა",
        "dxFileUploader-uploaded": "ატვირთულია",
        "dxFileUploader-readyToUpload": "მზადაა ასატვირთად",
        "dxFileUploader-uploadAbortedMessage": "ატვირთვა გაუქმდა",
        "dxFileUploader-uploadFailedMessage": "ატვირთვა ვერ მოხერხდა"
    }
}
